import { IntroWrapper } from '../__intro-elements';
import { IntroKeys } from '../intro-keys';

const AddProject = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Add Project:</b> Click this button to create a new project. Projects are containers that hold your files and
      stories.
    </p>
    <p>
      Give your project a meaningful name that describes what you're creating (e.g., "Summer Vacation 2024" or "Product
      Demo").
    </p>
  </IntroWrapper>
);

const AddFiles = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Add Files:</b> Once you have a project, click this button to upload your media files.
    </p>
    <p>
      <b>Requirements:</b>
    </p>
    <ul>
      <li>
        <b>Music:</b> At least one music file (required for beat synchronization)
      </li>
      <li>
        <b>Video/Photos:</b> At least one video or photo file
      </li>
    </ul>
    <p>
      <b>Tip:</b> Larger files take longer to upload and process. Consider using compressed formats for faster uploads.
    </p>
    <p>
      <b>Google Photos:</b> You can also import photos directly from your Google Photos account. Hold the <b>Shift</b>{' '}
      key to toggle the files chooser mode.
    </p>
  </IntroWrapper>
);

const AddStory = () => (
  <IntroWrapper size="medium">
    <p>
      <b>Add Story:</b> After adding files, create a story to organize your content.
    </p>
    <p>
      Stories help you manage different versions or narratives within the same project. For example, you might have:
    </p>
    <ul>
      <li>"Highlights Reel" - for a quick montage</li>
      <li>"Full Documentary" - for a longer, detailed version</li>
      <li>"Social Media Cut" - for shorter clips</li>
    </ul>
    <p>
      <b>Note:</b> You need at least one story before you can proceed to the Highlights page.
    </p>
  </IntroWrapper>
);

export const TUTS_PROJECTS = [
  { element: `[data-intro="${IntroKeys.createProject}"]`, intro: <AddProject /> },
  { element: `[data-intro="${IntroKeys.addFiles}"]`, intro: <AddFiles /> },
  { element: `[data-intro="${IntroKeys.createStory}"]`, intro: <AddStory /> },
];
